import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { OutlineButton, SolidButton } from '@/components/Button';
import SelectField from '@/forms/_fields_v2/SelectField';

EditableSelect.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  options: PropTypes.object.isRequired,
  optionLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  isEditing: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  editAriaLabel: PropTypes.string,
  placeholder: PropTypes.string
};

export default function EditableSelect(props) {
  const {
    label,
    value,
    options,
    optionLabel = 'name',
    isEditing,
    onEdit,
    onChange,
    onCancel,
    onSave,
    editAriaLabel = 'Edit field',
    placeholder = 'Select a value...'
  } = props;

  const [isSaving, setIsSaving] = useState(false);

  async function handleSave() {
    setIsSaving(true);
    try {
      await onSave();
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div>
      <div className="mb-2 flex items-center space-x-3">
        <h4 className="text-base font-semibold text-cs-gray-900">{label}</h4>
        <button
          type="button"
          className="text-cs-blue-500 hover:opacity-60"
          onClick={onEdit}
          aria-label={editAriaLabel}
        >
          <PencilSquareIcon className="size-5" />
        </button>
      </div>
      {isEditing ? (
        <>
          <SelectField
            value={value}
            options={options}
            optionLabel={optionLabel}
            placeholder={placeholder}
            onChange={onChange}
          />
          <div className="mt-4 flex items-center justify-between">
            <OutlineButton label="Cancel" onClick={onCancel} disabled={isSaving} />
            <SolidButton label="Save" onClick={handleSave} disabled={isSaving} />
          </div>
        </>
      ) : (
        <p className="text-base text-cs-gray-500">{value || placeholder}</p>
      )}
    </div>
  );
}
